"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
exports.EmailCanvasBlockTypeIcon = react_1.memo(props => {
    const { fieldType, type } = props;
    return (react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: type === 'repeater' || type === 'group' || type === 'social'
            ? type
            : fieldType === 'text'
                ? 'edit'
                : fieldType === 'ad'
                    ? 'ad'
                    : fieldType === 'unknown'
                        ? 'question'
                        : fieldType === 'html'
                            ? 'html'
                            : fieldType === 'datetime'
                                ? 'calendar'
                                : fieldType === 'url'
                                    ? 'externalLink'
                                    : 'edit', iconStyle: "regular", size: "lg", className: "mr-2 text-muted" }));
});
//# sourceMappingURL=BlockTypeIcon.js.map